/** @format */

import axios from "axios";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_Ratings;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listar: async (Obj, alertMessage) => {
    try {
      let rsnota = await axios.get(
        `${ENDPOINT}${Obj.codigo}/${Obj.courseId}/${Obj.courseSection}/${Obj.period}`,
        { headers: headers }
      );
      if (dataUser == undefined) {
        getAlert(Constantes().msmNotas, Constantes().login, alertMessage);
      } else if (rsnota.data.detail.gradeArray.length == 0) {
        getAlert(
          Constantes().msmNotas,
          dataUser != null ? "./home" : "",
          alertMessage
        );
      }
      return await rsnota.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
};

export default API;
